import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { DataService } from '../helpers/data.service';

@Directive({
  selector: '[renderIf]',
})
export class RenderIfDirective implements OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private renderCriteria?: {
    roles?: string | string[];
    right: string | string[];
    departments?: string | string[];
    excludeDepartments?: string | string[];
  };

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private dataService: DataService
  ) { }

  @Input() set renderIf(
    criteria:
      | {
        roles?: string | string[];
        right: string | string[];
        departments?: string | string[];
        excludeDepartments?: string | string[];
      }
      | undefined
  ) {
    this.renderCriteria = criteria;
    this.updateView();
  }

  // private updateView(): void {

  //   this.viewContainer.clear();

  //   if (!this.renderCriteria) {
  //     return;
  //   }

  //   const { roles, right } = this.renderCriteria;
  //   const role = Array.isArray(roles) ? roles : [roles];
  //   if (!roles) {
  //     this.viewContainer.createEmbeddedView(this.templateRef);
  //     return;
  //   }
  //   if (role.includes(this.dataService.roleValue)) {
  //     if (['customer', 'superadmin'].includes(this.dataService.roleValue)) {
  //       // Render immediately for universal roles
  //       this.viewContainer.createEmbeddedView(this.templateRef);
  //       return;
  //     }

  //     // Delegate permission-checking to the DataService
  //     if (this.dataService.hasPermission(right)) {
  //       this.viewContainer.createEmbeddedView(this.templateRef);
  //     }
  //   }
  // }

  private updateView(): void {
    this.viewContainer.clear();

    if (!this.renderCriteria) return;

    const { roles, right, departments, excludeDepartments } =
      this.renderCriteria;

    const userRole = this.dataService.roleValue;
    const emp = this.dataService.employeeValue
    const userDept = emp?.department;

    const roleList = roles
      ? Array.isArray(roles)
        ? roles
        : [roles]
      : null;

    const deptList = departments
      ? Array.isArray(departments)
        ? departments
        : [departments]
      : null;

    const excludeDeptList = excludeDepartments
      ? Array.isArray(excludeDepartments)
        ? excludeDepartments
        : [excludeDepartments]
      : null;

    if (roleList && !roleList.includes(userRole)) return;

    if (userRole === 'employee') {
      if (deptList && !deptList.includes(userDept)) return;
      if (excludeDeptList && excludeDeptList.includes(userDept)) return;
    }

    if (['customer', 'superadmin'].includes(userRole)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    if (!right || this.dataService.hasPermission(right)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
